<template>
  <div class="formsign">
    <div class="pagePopMask pFull" v-if="formsign" @click="cancelImpEdit"></div>
    <div class="pagePop w1280 pCenter" v-if="formsign">
      <div class="w">
        <div class="tit fnt_24">{{ titleName }}</div>
        <div class="tips">{{ placeWrite }} </div>
        <div>
          <div class="stform">
            <a-form-model ref="realForm" :model="personInfo">
              <a-row :gutter="18">
                <template v-for="item in teamMemberList">
                  <div :key="item.fieldSort" v-if="item.isShow === '1' || item.isDoubleCheck">
                    <a-col :xs="24" :sm="24" :md="item.isStandalone === '0' ? 12 : 24" :lg="item.isStandalone === '0' ? 12 : 24" :xl="item.isStandalone === '0' ? 12 : 24">
                      <a-form-model-item
                        :label="item.fieldName" :prop="item.fieldCode"
                        :rules="buildFieldRules(item)"
                        :extra="item.prompt && item.prompt[0] ? item.prompt[0] : ''"
                      >
                        <!-- 生日选择框 -->
                        <a-date-picker
                          value-format="YYYY-MM-DD"
                          :locale="locale"
                          v-if="item.fieldCode === 'birthday'"
                          v-model="personInfo[item.fieldCode]"
                          @change="onBirthdayChange($event)"
                        />

                        <!-- 下拉框 -->
                        <a-select
                          v-else-if="item.fieldCode === 'company' && item.isDoubleCheck"
                          show-search
                          allow-clear
                          :filter-option="false"
                          :placeholder="pleaseSelect"
                          :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                          v-model="personInfo[item.fieldCode]"
                          @search="searchCollege"
                        >
                          <a-select-option v-for="(fi, index) in filterdCollegeList" :key="`formmsg-${fi.identificationCode || index}-${fi.name}`" :value="fi.name">
                            {{ fi.name }}
                          </a-select-option>
                        </a-select>
                        <a-select
                          :label-in-value="true"
                          :placeholder="pleaseSelect" v-else-if="item.fieldCode === 'countryCode'" @change="handleProvinceChange($event, '-1')"
                          v-model="personInfo[item.fieldCode]"
                          :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                        >
                          <a-select-option :value="po.parentId" v-for="po in item.list" :key="po.parentId">
                            {{ po.title }}
                          </a-select-option>
                        </a-select>
                        <a-select
                          :label-in-value="true"
                          :placeholder="pleaseSelect" v-else-if="item.fieldCode === 'cityCode'"
                          v-model="personInfo[item.fieldCode]"
                          :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                        >
                          <a-select-option :value="po.itemValue" v-for="po in item.list" :key="po.itemValue">
                            {{ po.itemText }}
                          </a-select-option>
                        </a-select>
                        <a-select
                          :placeholder="pleaseSelect" v-else-if="item.fieldType === 'select'"
                          v-model="personInfo[item.fieldCode]"
                          :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                        >
                          <a-select-option :value="po.itemValue" v-for="po in item.list" :key="po.itemValue">
                            {{ po.itemText }}
                          </a-select-option>
                        </a-select>

                        <!-- 普通输入框 -->
                        <a-input
                          @input="handleNumberInput($event, item.fieldCode, '-1')"
                          v-else-if="item.fieldType === 'text' && item.fieldCode === 'userPhone'"
                          :disabled="item?.readOnly"
                          v-model="personInfo[item.fieldCode]"
                        />
                        <a-input
                          v-else-if="item.fieldType === 'text'"
                          :disabled="item?.readOnly"
                          v-model="personInfo[item.fieldCode]"
                        />

                        <!-- 普通单选框 -->
                        <a-radio-group
                          v-else-if="item.fieldType === 'radio' && item.fieldCode === 'companyType'"
                          @change="onChangeCompany"
                          v-model="personInfo[item.fieldCode]"
                        >
                          <a-radio :value="ca.itemValue" v-for="(ca) in item.list" :key="ca.itemValue">
                            {{ ca.itemText }}
                          </a-radio>
                        </a-radio-group>
                        <a-radio-group
                          v-else-if="item.fieldType === 'radio' && item.fieldCode === 'jobType'"
                          @change="onChangeJob($event, '-1')"
                          v-model="personInfo[item.fieldCode]"
                        >
                          <a-radio :value="ca.itemValue" v-for="(ca) in item.list" :key="ca.itemValue">
                            {{ ca.itemText }}
                          </a-radio>
                        </a-radio-group>
                        <a-radio-group
                          v-else-if="item.fieldType === 'radio'"
                          v-model="personInfo[item.fieldCode]"
                        >
                          <a-radio :value="ca.itemValue" v-for="(ca) in item.list" :key="ca.itemValue">
                            {{ ca.itemText }}
                          </a-radio>
                        </a-radio-group>

                        <!-- 文件上传 -->
                        <file-upload-new v-else-if="item.fieldType === 'upload' && item.fieldCode === 'studentUrl' " v-model="personInfo[item.fieldCode]" accept=".jpg, .jpeg, .png, .gif, .pdf" />
                        <div class="flex-y-center gap-x-8" v-else-if="item.fieldType === 'upload' && item.fieldCode === 'underAgeFileUrl'">
                          <file-upload-new v-model="personInfo[item.fieldCode]" accept=".jpg, .jpeg, .png, .gif, .pdf" />
                          <a-tooltip placement="right">
                            <a-icon type="question-circle" />
                            <template slot="title">
                              <span v-html="globalDataArray.siteTemplateLanguage.sign_birthday_file_template"></span>
                            </template>
                          </a-tooltip>
                        </div>
                        <file-upload-new v-else-if="item.fieldType === 'upload'" v-model="personInfo[item.fieldCode]" />
                      </a-form-model-item>
                    </a-col>
                  </div>
                </template>
              </a-row>
            </a-form-model>
          </div>
        </div>
        <div class="btnBox fnt_18">
          <div class="btn btn1" :class="{ 'btn-disabled': submitting || !formReady }" @click="confirmImpEdit">{{ subButton }}</div>
          <div class="btn btn2" :class="{ 'btn-disabled': submitting }" @click="cancelImpEdit">{{ globalDataArray.siteTemplateLanguage.cancel }}</div>
        </div>
        <div class="close" @click="cancelImpEdit"></div>
      </div>
    </div>
  </div>
</template>

<script>
import FileUploadNew from '@/views/person/component/FileUploadNew.vue'
import {
  boolAuth,
  competitionSub,
  getCollegeList,
  joinTeam,
  queryByParentId,
  verifyTwo,
  verifyUserInfo
} from '@/api/saiti'
import { getCityList, getCompetitionDict, getProvinceList } from '@/api/api'
import debounce from 'lodash/debounce'
import { message } from 'ant-design-vue'
import zhCN from 'ant-design-vue/es/date-picker/locale/zh_CN'
import enUS from 'ant-design-vue/es/date-picker/locale/en_US'
import moment from 'moment'
import 'moment/locale/zh-cn'
import { threeVerification, updateTeamRecord } from '@/api/person/person'

export default {
  name: 'FormmsgEditNew',
  components: { FileUploadNew },
  props: {
    formsign: {
      type: Boolean,
      default: false
    },
    titleName: {
      type: String,
      default: ''
    },
    subButton: {
      type: String,
      default: ''
    },
    placeWrite: {
      type: String,
      default: ''
    },
    curInfoArray: {
      type: Object,
      default: () => ({})
    },
    personList: {
      type: Object,
      default: () => ({})
    },
    teamArray: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    this.searchCollege = debounce(this.searchCollege, 800)
    this.searchCollege1 = debounce(this.searchCollege1, 800)
    return {
      mobileNumberRule: '',
      studentInfo: {},
      model: {
        data: {
          categoryCompId: [],
          categoryId: '',
          competitionId: '',
          nation: '',
          teamName: '',
          teamType: '',
          companyType: '',
          jobType: '',
          language: '',
          countryCode: '',
          cityCode: ''
        },
        temp: []
      },
      personInfo: {
        categoryCompId: [],
        categoryId: '',
        competitionId: '',
        nation: '',
        teamName: '',
        teamType: '',
        companyType: '',
        jobType: '',
        language: '',
        countryCode: '',
        cityCode: ''
      },
      globalLanguage: this.globalDataArray.siteInfo.language,
      provinceList: [], // 省份列表
      allList: [], // 全部字段信息
      columnList: [], // 团队字段信息
      showList: [], // 队长字段信息
      teamMemberList: [], // 队员字段信息
      dictCodeArray: [], // 字典值数组
      verify: {}, // 是否开启验证
      limitNum: 0, // 限制队员数量
      filterdCollegeList: [], // 缓存学校
      staging: {}, // 暂存对象
      collegeList: [], // 学院列表
      submitting: false, // 提交状态，防重提交
      formReady: false, // 表单是否渲染完成
      locale: this.globalDataArray.siteInfo.language == 'zh_CN' ? zhCN : enUS,
      moment
    }
  },
  watch: {
    formsign: {
      immediate: true,
      async handler(val) {
        if (val) {
          // 开始加载，重置状态
          this.submitting = false
          this.formReady = false

          try {
            if (this.$refs.realForm) {
              this.$refs.realForm.resetFields()
            }
            await this.initDictFun()
            if (this.personList && Object.keys(this.personList).length !== 0) {
              this.edit()
            }

            // 表单加载完成
            this.formReady = true
          } catch (error) {
            console.error('表单初始化失败:', error)
            this.formReady = false
          }
        } else {
          // 关闭弹窗，重置状态
          this.submitting = false
          this.formReady = false
        }
      }
    }
  },
  computed: {
    pleaseSelect() {
      return this.globalDataArray.siteTemplateLanguage.please_select
    },
    pleaseInput() {
      return this.globalDataArray.siteTemplateLanguage.please_enter
    }
  },
  methods: {
    // 判断是否为青少年模板
    isYouthTemplate() {
      // 检查模板中是否有 grade 字段且是显示的
      const gradeField = this.allList.find(item =>
        item.fieldCode === 'grade' && item.isShow === '1'
      )

      return !!gradeField
    },

    // 构建字段验证规则（统一管理 required / trigger / 校验器）
    buildFieldRules(item) {
      // 选择类字段（单选、下拉、日期）使用 change 触发 + "请选择" 前缀
      const isSelectLike = item.fieldType === 'radio' || item.fieldType === 'select' || item.fieldCode === 'birthday'
      const trigger = isSelectLike ? 'change' : 'blur'
      const prefix = isSelectLike ? this.pleaseSelect : this.pleaseInput
      const message = prefix + item.fieldName + '!'

      // 省市字段：仅需必填规则，无需额外校验
      if (item.fieldCode === 'countryCode' || item.fieldCode === 'cityCode') {
        return [{ required: item.verificationType, message, trigger }]
      }

      const required = this.shouldFieldBeRequired(item)
      const rules = [{ required, message, trigger }]

      // 联系方式校验（邮箱/手机）
      const isContactField = item.verificationType === 'email' || item.verificationType === 'phone'
      rules.push({
        validator: isContactField
          ? (rule, value, callback) => this.validateContactInfo(rule, value, callback, item, '-1')
          : undefined,
        trigger: 'blur'
      })

      // 身份证校验
      rules.push({
        validator: item.verificationType === 'idCard'
          ? (rule, value, callback) => this.validateID(rule, value, callback, '-1')
          : undefined,
        trigger: 'blur'
      })

      return rules
    },

    // 判断是否未成年（距今小于18岁）
    isUnderAge(birthday) {
      if (!birthday) return false
      const today = this.moment()
      const birthDate = this.moment(birthday)
      return today.diff(birthDate, 'years') < 18
    },

    // 生日变更联动：控制未成年附件字段显示
    onBirthdayChange(date) {
      const isUnderAge = this.isUnderAge(date)
      this.toggleUnderAgeFileUrl(isUnderAge)
    },

    // 切换未成年附件字段显示状态
    toggleUnderAgeFileUrl(show) {
      const value = show ? '1' : '0'
      this.teamMemberList.forEach(item => {
        if (item.fieldCode === 'underAgeFileUrl') {
          item.isShow = value
        }
      })
      if (!show) {
        this.personInfo.underAgeFileUrl = ''
      }
    },

    edit() {
      console.log(this.personList, 'this.personList')
      if (this.personList.teamType === '02') {
        this.teamMemberList.forEach(colItem => {
          if (colItem.fieldCode === 'fileUrl') {
            colItem.isShow = '1'
          }
        })
      }
      if (this.personList.jobType === '02' && this.personList.companyType === '02') {
        this.teamMemberList.forEach(colItem => {
          if (colItem.fieldCode === 'educational') {
            colItem.isShow = '1'
          }
          if (colItem.fieldCode === 'studentUrl') {
            colItem.isShow = '1'
          }
          if (colItem.fieldCode === 'onlineCode') {
            colItem.isShow = '1'
          }
        })
      }
      if (this.personList.companyType) {
        const index = this.teamMemberList.findIndex(item => item.fieldCode === 'companyType' && item.isShow === '1')
        this.teamMemberList.forEach(colItem => {
          if (colItem.fieldCode === 'company' && index !== -1) {
            colItem.isShow = '1'
          }
        })
      }
      this.teamMemberList.forEach(item => {
        if (item.fieldCode === 'userName') {
          item.readOnly = true
        }
        if (item.fieldCode === 'userPhone') {
          item.readOnly = true
        }
      })
      this.personInfo = structuredClone(this.personList)
      console.log(this.teamMemberList, 'this.teamMemberList')

      // 检查生日，控制未成年附件字段显示
      if (this.personInfo.birthday) {
        this.toggleUnderAgeFileUrl(this.isUnderAge(this.personInfo.birthday))
      }

      // 编辑模式下，如果省份有值，主动加载城市数据
      this.$nextTick(() => {
        this.loadCityDataIfProvinceExists()
      })
    },
    // 初始化数据
    async initDictFun() {
      this.limitNum = this.curInfoArray.teamsUsers
      await this.getCollegeList()
      const res = await getProvinceList()
      if (res.success) {
        this.provinceList = res.result // 省或国家列表
      }
      // 获取报名模板
      await this.findAllColunm()
      // 获取是否开启验证
      const params = 'language=' + this.globalLanguage + '&competitionId=' + this.curInfoArray.competitionId
      const boolAuthRes = await boolAuth(params)
      if (boolAuthRes.success) {
        this.verify = boolAuthRes.result
      }
    },
    async findAllColunm() {
      const paTemp = 'language=' + this.globalLanguage + '&templateId=' + this.curInfoArray.templateId
      const res = await queryByParentId(paTemp)
      if (res.success) {
        // 全部字段信息
        this.allList = JSON.parse(res.result.fieldJson)
        // 获取所有字典值
        this.allList.forEach(item => {
          // 检查 item 中是否有 dictCode 属性
          if (item.dictCode) {
            // 将 dictCode 数据添加到数组中
            this.dictCodeArray.push(item.dictCode)
          }
          if (item.defaultValue) {
            this.staging[item.fieldCode] = item.defaultValue
          }
        })
        this.personInfo = { ...this.personInfo, ...this.staging }
        await this.findDictCode()
      }
    },
    // 给字段值绑定字典列表
    async findDictCode() {
      const param = 'dictCode=' + this.dictCodeArray.join(',') + ',mobile_number'
      const res = await getCompetitionDict(param)
      if (res.success) {
        const dictCodeList = res.result
        dictCodeList.forEach(item => {
          if (item.dictCode === 'mobile_number') {
            this.mobileNumberRule = item.list[0]?.itemValue
          }
        })
        this.allList = this.allList.map(showItem => {
          const dictItem = dictCodeList.find(dictItem => dictItem.dictCode === showItem.dictCode)
          if (dictItem) {
            showItem.list = dictItem.list
          }
          if (showItem.fieldCode === 'countryCode') {
            showItem.list = this.provinceList
          }
          return showItem
        })
        this.columnList = this.allList.filter(item => item.isTeam === 1)
        this.showList = this.allList.filter(item => item.isTeam === 0)
        const teamMemberListCopy = JSON.parse(JSON.stringify(this.showList))
        teamMemberListCopy.forEach(item => {
          if (item.fieldCode === 'leaderName') {
            item.fieldName = this.globalDataArray.siteTemplateLanguage.team_member_name
            item.fieldCode = 'userName'
          }
        })
        this.teamMemberList = teamMemberListCopy

        // 初始化：隐藏未成年附件字段（由生日联动控制显示）
        this.teamMemberList.forEach(item => {
          if (item.fieldCode === 'underAgeFileUrl') {
            item.isShow = '0'
          }
        })

        console.log(this.columnList, 'lllll')
        console.log(this.showList, 'mmmmmm')
        console.log(this.teamMemberList, 'zzzzz')
      }
    },
    confirmImpEdit() {
      // 防重提交和表单状态检查
      if (this.submitting) {
        return
      }

      if (!this.formReady) {
        return
      }

      // 立即设置提交状态，防止快速点击
      this.submitting = true

      this.$refs['realForm'].validate(async (err, valid) => {
        if (err) {
          try {
            console.log(this.personInfo, 'this.personInfo')
            console.log(this.teamArray, 'this.teamArray')
            const param = structuredClone(this.personInfo)
            if (param.countryCode?.key) {
              const countryKL = param.countryCode
              if (countryKL.key) {
                param['countryCode'] = countryKL.key
              }
              if (countryKL.label) {
                param['countryName'] = countryKL.label
              }
            } else {
              param['countryCode'] = ''
              param['countryName'] = ''
            }

            if (param.cityCode?.key) {
              const cityKL = param.cityCode
              if (cityKL.key) {
                param['cityCode'] = cityKL.key
              }
              if (cityKL.label) {
                param['cityName'] = cityKL.label
              }
            } else {
              param['cityCode'] = ''
              param['cityName'] = ''
            }

            if (!param.isCaptain) {
              param.isCaptain = 0
            }
            param.templateId = this.curInfoArray.templateId
            param.parentId = this.teamArray.parentId
            param.teamName = this.teamArray.teamName
            param.teamType = this.teamArray.teamType
            param.teamNo = this.teamArray.teamNo
            param.competitionId = this.teamArray.competitionId
            param.categoryId = this.teamArray.categoryId
            param.leaderName = this.teamArray.leaderName
            param.zoneId = this.teamArray.zoneId
            param.currentLanguge = this.teamArray.currentLanguge
            param.language = this.teamArray.currentLanguge
            const newParam = structuredClone(param)
            if (newParam.isCaptain === 1) {
              newParam.leaderName = newParam.userName
            }
            delete newParam.temp
            delete newParam.sigupJson
            newParam.sigupJson = JSON.stringify(newParam)
            console.log(newParam, 'newParam')
            if (this.personList && Object.keys(this.personList).length !== 0) {
              const res = await updateTeamRecord(newParam)
              if (res.success) {
                message.success(res.result)
                this.$emit('update:formsign', false)
                this.$emit('SignupRecordList')
                this.personInfo = {}
              } else {
                message.error(res.message)
              }
            } else {
              const res = await joinTeam(newParam)
              if (res.success) {
                message.success(res.result)
                // 自定义事件，把res传给父组件,发射事件
                this.$emit('itemclick', 1) // itemclick  为事件名
                this.$emit('update:formsign', false)
                this.personInfo = {}
              } else {
                if (res.code == '403') {
                  message.error(res.message)
                }
              }
            }
          } catch (error) {
            console.error('提交失败:', error)
            message.error('提交失败，请稍后重试')
          } finally {
          // 重置提交状态
            this.submitting = false
          }
        } else {
          // 验证失败，重置提交状态
          this.submitting = false
          return false
        }
      })
    },
    cancelImpEdit() {
      // 提交中时阻止取消
      if (this.submitting) {
        return
      }

      this.personInfo = {
        categoryCompId: [],
        categoryId: '',
        competitionId: '',
        nation: '',
        teamName: '',
        teamType: '',
        companyType: '',
        jobType: '',
        language: '',
        countryCode: '',
        cityCode: ''
      }
      this.teamMemberList = []
      this.submitting = false
      this.formReady = false
      this.$emit('itemclick', '2') // itemclick  为事件名
      this.$emit('update:formsign', false)
    },
    // 切换团队类型
    onChangeFieldType(e) {
      console.log(e)
      const newValue = e.target.value === '02' ? '1' : '0'
      this.columnList.forEach(item => {
        if (item.fieldCode === 'fileUrl') {
          item.isShow = newValue
        }
      })
    },
    getVerificationIdCard(k) {
      if (k === '-1') {
        return this.personInfo.idCard
      }
      return this.model.temp?.[k]?.idCard
    },

    shouldRunTwoFactorVerification(k) {
      if (!this.verify.bootTwo) {
        return false
      }
      if (!this.verify.boolThree) {
        return true
      }
      const idCard = this.getVerificationIdCard(k)
      return !idCard || String(idCard).trim() === ''
    },

    validateContactInfo(rule, value, callback, item, k) {
      // 如果值为空，直接通过验证（适用于英文用户不需要填写联系方式的情况）
      if (!value || value.trim() === '') {
        callback()
        return
      }

      // 根据验证类型进行格式验证
      if (item.verificationType === 'email') {
        // 邮箱格式验证
        // 更严格的邮箱格式正则表达式
        const emailRegex = /^[a-zA-Z0-9]([a-zA-Z0-9._-])*[a-zA-Z0-9]@[a-zA-Z0-9]([a-zA-Z0-9.-])*[a-zA-Z0-9]\.[a-zA-Z]{2,}$/

        // 基本格式验证
        if (!emailRegex.test(value.trim())) {
          callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
          return
        }

        // 额外的格式限制检查
        const trimmedValue = value.trim()

        // 检查连续的点号
        if (trimmedValue.includes('..')) {
          callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
          return
        }

        // 检查邮箱长度（总长度不超过254字符，本地部分不超过64字符）
        if (trimmedValue.length > 254) {
          callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
          return
        }

        const [localPart, domainPart] = trimmedValue.split('@')
        if (localPart.length > 64) {
          callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
          return
        }

        // 检查域名部分是否过长
        if (domainPart && domainPart.length > 253) {
          callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
          return
        }
      } else if (item.verificationType === 'phone') {
        // 手机号格式验证
        const regID = new RegExp(this.mobileNumberRule.replace(/^\/|\/$/g, ''))
        if (!regID.test(value)) {
          callback(new Error('请输入正确的手机号格式 '))
          return
        }
      }

      // 格式验证通过，继续进行重复性验证
      let param = {}
      if (k === '-1') {
        param = {
          id: this.personInfo.id,
          name: this.personInfo.userName,
          phone: this.personInfo.userPhone,
          email: this.personInfo.userEmail,
          competitionId: this.curInfoArray.competitionId
        }
      } else {
        param = {
          name: this.model.temp[k].userName,
          phone: this.model.temp[k].userPhone,
          email: this.model.temp[k].userEmail,
          competitionId: this.curInfoArray.competitionId
        }
      }

      console.log(`validateContactInfo: 进行重复性验证，参数:`, param)
      const list = []
      list.push(param)
      verifyUserInfo(list).then(res => {
        if (res.success) {
          if (this.shouldRunTwoFactorVerification(k)) {
            verifyTwo(param).then(res => {
              if (res.success) {
                const isValid = res.result
                callback()
              } else {
                callback(new Error(this.globalDataArray.siteTemplateLanguage.authentication_failed))
              }
            })
          } else {
            callback()
          }
        } else {
          // 使用后端返回的具体错误信息
          callback(new Error(res.message || this.globalDataArray.siteTemplateLanguage.already_registered))
        }
      }).catch(error => {
        console.error('用户信息验证失败:', error)
        callback(new Error('验证失败，请稍后重试'))
      })
    },

    validateEmail(rule, value, callback) {
      // 如果值为空，直接通过验证（由必填规则单独处理）
      if (!value || value.trim() === '') {
        callback()
        return
      }

      // 更严格的邮箱格式正则表达式
      const emailRegex = /^[a-zA-Z0-9]([a-zA-Z0-9._-])*[a-zA-Z0-9]@[a-zA-Z0-9]([a-zA-Z0-9.-])*[a-zA-Z0-9]\.[a-zA-Z]{2,}$/

      // 基本格式验证
      if (!emailRegex.test(value.trim())) {
        callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
        return
      }

      // 额外的格式限制检查
      const trimmedValue = value.trim()

      // 检查连续的点号
      if (trimmedValue.includes('..')) {
        callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
        return
      }

      // 检查邮箱长度（总长度不超过254字符，本地部分不超过64字符）
      if (trimmedValue.length > 254) {
        callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
        return
      }

      const [localPart, domainPart] = trimmedValue.split('@')
      if (localPart.length > 64) {
        callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
        return
      }

      // 检查域名部分是否过长
      if (domainPart && domainPart.length > 253) {
        callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
        return
      }

      callback()
    },

    // 保持向后兼容性，将旧方法重定向到新方法
    validateNumber(rule, value, callback) {
      this.validateEmail(rule, value, callback)
    },

    // 判断字段是否应该显示为必填
    shouldFieldBeRequired(item) {
      // 未成年附件字段：仅在显示时必填（由生日联动控制显示）
      if (item.fieldCode === 'underAgeFileUrl') {
        return true
      }

      // 邮箱字段按照正常逻辑处理，不做语言区分
      if (['userMail', 'userMailNew'].includes(item.fieldCode)) {
        return item.verificationType
      }

      // 如果不是手机号或身份证字段，按原逻辑处理
      if (!['userPhone', 'userPhoneNew', 'idCard'].includes(item.fieldCode) && item.verificationType !== 'phone' && item.verificationType !== 'idCard') {
        return item.verificationType
      }

      // 对于手机号和身份证字段，需要根据语言状态判断
      let userLanguage = null

      // 获取用户语言状态
      if (this.personList && Object.keys(this.personList).length !== 0) {
        // 编辑模式：从personList获取语言
        userLanguage = this.personList.language

        // 如果没有直接的language字段，从sigupJson解析
        if (!userLanguage && this.personList.sigupJson) {
          try {
            const signupData = JSON.parse(this.personList.sigupJson)
            userLanguage = signupData.language || signupData.currentLanguge
          } catch (e) {
            console.log('解析 sigupJson 失败:', e)
          }
        }
      }

      // 新建模式：从teamArray获取语言
      if (!userLanguage && this.teamArray && this.teamArray.currentLanguge) {
        userLanguage = this.teamArray.currentLanguge
      }

      // 全局语言兜底
      if (!userLanguage) {
        userLanguage = this.globalLanguage
      }

      // 只有当语言是中文(zh_CN)时，手机号和身份证字段才显示为必填
      if (userLanguage && userLanguage.toLowerCase() === 'zh_cn') {
        return item.verificationType || ['userPhone', 'userPhoneNew', 'idCard'].includes(item.fieldCode) || item.verificationType === 'phone' || item.verificationType === 'idCard'
      }

      // 非中文状态下，手机号和身份证字段不显示为必填
      return false
    },
    // 验证输入的字符串是否符合中国的身份证号码格式。身份证号码可以是15位或18位数字，其中18位的最后一位可以是数字或字母X（大小写均可）
    validateID(rule, value, callback, k) {
      // 如果值为空，直接通过验证（由必填规则单独处理）
      if (!value || value.trim() === '') {
        callback()
        return
      }

      const regID = new RegExp(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/)
      if (!regID.test(value.trim())) {
        callback(new Error('请输入正确的身份证格式'))
        return
      }

      // 身份证格式验证通过，检查是否需要进行三要素验证
      if (this.verify.boolThree) {
        // 检查语言状态，只有中文用户才进行身份证三要素验证
        let userLanguage = null

        // 获取用户语言状态
        if (this.personList && Object.keys(this.personList).length !== 0) {
          // 编辑模式：从personList获取语言
          userLanguage = this.personList.language

          // 如果没有直接的language字段，从sigupJson解析
          if (!userLanguage && this.personList.sigupJson) {
            try {
              const signupData = JSON.parse(this.personList.sigupJson)
              userLanguage = signupData.language || signupData.currentLanguge
            } catch (e) {
              console.log('解析 sigupJson 失败:', e)
            }
          }
        }

        // 新建模式：从teamArray获取语言
        if (!userLanguage && this.teamArray && this.teamArray.currentLanguge) {
          userLanguage = this.teamArray.currentLanguge
        }

        // 全局语言兜底
        if (!userLanguage) {
          userLanguage = this.globalLanguage
        }

        // 只有中文用户才进行三要素验证
        if (!userLanguage || userLanguage.toLowerCase() !== 'zh_cn') {
          console.log(`身份证验证：非中文用户(${userLanguage})，跳过三要素验证`)
          callback()
          return
        }

        console.log(`身份证验证：中文用户(${userLanguage})，执行三要素验证`)
        let param = {}
        let name = ''
        let phone = ''

        // 根据不同场景获取姓名和手机号
        if (k === '-1') {
          name = this.personInfo.userName
          phone = this.personInfo.userPhone
          param = {
            name: name,
            phone: phone,
            cardNo: value.trim(),
            competitionId: this.curInfoArray.competitionId
          }
        } else {
          name = this.model.temp[k].userName
          phone = this.model.temp[k].userPhone
          param = {
            name: name,
            phone: phone,
            cardNo: value.trim(),
            competitionId: this.curInfoArray.competitionId
          }
        }

        // 检查姓名和手机号是否都不为空
        if (!name || name.trim() === '') {
          callback(new Error('请先填写姓名'))
          return
        }

        if (!phone || phone.trim() === '') {
          callback(new Error('请先填写手机号'))
          return
        }

        // 验证手机号格式
        if (this.mobileNumberRule) {
          const phoneRegex = new RegExp(this.mobileNumberRule.replace(/^\/|\/$/g, ''))
          if (!phoneRegex.test(phone.trim())) {
            callback(new Error('请先填写正确格式的手机号'))
            return
          }
        }

        // 所有信息都填写正确，调用三要素验证接口
        // console.log('身份证三要素验证参数:', param)
        threeVerification(param).then(res => {
          if (res.success) {
            callback()
          } else {
            callback(new Error(res.message))
          }
        }).catch(error => {
          console.error('三要素验证接口调用失败:', error)
          callback(new Error('身份证验证失败，请稍后重试'))
        })
      } else {
        callback()
      }
    },
    validatePhone(rule, value, callback, k) {
      // 如果值为空，直接通过验证（适用于英文用户不需要填写联系方式的情况）
      if (!value || value.trim() === '') {
        // console.log(`validatePhone: 值为空，直接通过验证`)
        callback()
        return
      }

      const regID = new RegExp(this.mobileNumberRule.replace(/^\/|\/$/g, ''))
      if (!regID.test(value)) {
        callback(new Error('请输入正确的手机号格式 '))
        return
      }

      // 格式正确，继续进行重复性验证
      let param = {}
      if (k === '-1') {
        param = {
          id: this.personInfo.id,
          name: this.personInfo.userName,
          phone: value,
          email: this.personInfo.userEmail,
          competitionId: this.curInfoArray.competitionId
        }
      } else {
        param = {
          name: this.model.temp[k].userName,
          phone: value,
          competitionId: this.curInfoArray.competitionId
        }
      }

      console.log(`validatePhone: 进行重复性验证，参数:`, param)
      const list = []
      list.push(param)
      verifyUserInfo(list).then(res => {
        if (res.success) {
          if (this.shouldRunTwoFactorVerification(k)) {
            verifyTwo(param).then(res => {
              if (res.success) {
                const isValid = res.result
                callback()
              } else {
                callback(new Error(this.globalDataArray.siteTemplateLanguage.authentication_failed))
              }
            })
          } else {
            callback()
          }
        } else {
          // 使用后端返回的具体错误信息
          callback(new Error(res.message || this.globalDataArray.siteTemplateLanguage.already_registered))
        }
      })
    },
    // 队长动态搜索学校名字
    searchCollege(value) {
      if (!value) {
        return
      }
      const filteredList = this.collegeList?.filter(item => {
        if (item.name.indexOf(value) > -1) {
          return true
        }
        return false
      }) || []

      // 去重处理，基于学校名称和标识码
      const uniqueList = filteredList.filter((item, index, self) => {
        return self.findIndex(i => i.name === item.name && i.identificationCode === item.identificationCode) === index
      })

      this.filterdCollegeList = uniqueList
    },
    // 队员学校搜索
    searchCollege1(value, k) {
      const filteredList = this.collegeList.filter(item => {
        return item.name.indexOf(value) > -1
      })

      // 去重处理，基于学校名称和标识码
      const uniqueList = filteredList.filter((item, index, self) => {
        return self.findIndex(i => i.name === item.name && i.identificationCode === item.identificationCode) === index
      })

      console.log(uniqueList, 'filteredList after deduplication')
      const exist = this.model.temp[k]
      this.$set(this.model.temp[k], 'filterdCollegeList', uniqueList)
    },

    // 删除单个队员
    delPerson(index) {
      this.model['temp'].splice(index, 1)
    },
    addPerson() {
      const that = this

      if (that.limitNum == null) {
        that.limitNum = 0
      }

      const hasMemberNum = this.model['temp'].length

      if (hasMemberNum >= that.limitNum) {
        that.$message.warning('成员总数超出限制！')
        return false
      }
      const itemParam = {
        userName: '',
        categoryId: '',
        competitionId: '',
        nation: '',
        teamName: '',
        teamType: '',
        companyType: '',
        jobType: '',
        language: '',
        countryCode: {},
        cityCode: {},
        teamList: this.teamMemberList,
        filterdCollegeList: []
      }
      this.model['temp'].push(itemParam)
    },

    // 切换单位类型
    onChangeCompany(e) {
      const newValue = e.target.value !== '02' ? '1' : '0'
      this.teamMemberList.forEach(item => {
        if (item.fieldCode === 'company') {
          item.isShow = newValue
          item.isDoubleCheck = e.target.value === '02'
        }
      })
      if (newValue === '0' && this.personInfo.jobType === '02') {
        this.changeStudent(this.teamMemberList, '1')
      } else {
        this.changeStudent(this.teamMemberList, '0')
      }
    },

    // 切换职业
    onChangeJob(e, k) {
      console.log(e)
      const newValue = e.target.value === '02' ? '1' : '0'
      if (k === '-1') {
        if (this.personInfo.companyType !== '02') {
          this.changeStudent(this.teamMemberList, '0')
          return
        }
        this.teamMemberList.forEach(item => {
          if (item.fieldCode === 'educational') {
            item.isShow = newValue
          }
          if (item.fieldCode === 'studentUrl') {
            item.isShow = newValue
          }
          if (item.fieldCode === 'onlineCode') {
            item.isShow = newValue
          }
        })
      } else {
        this.model.temp[k].teamList.forEach(item => {
          if (item.fieldCode === 'educational') {
            item.isShow = newValue
          }
          if (item.fieldCode === 'studentUrl') {
            item.isShow = newValue
          }
          if (item.fieldCode === 'onlineCode') {
            item.isShow = newValue
          }
        })
      }
    },

    changeStudent(listStudent, value) {
      listStudent.forEach(item => {
        if (item.fieldCode === 'educational') {
          item.isShow = value
        }
        if (item.fieldCode === 'studentUrl') {
          item.isShow = value
        }
        if (item.fieldCode === 'onlineCode') {
          item.isShow = value
        }
      })
    },

    handleNumberInput(e, fieldCode, k) {
      // 过滤非数字字符
      const value = e.target.value.replace(/[^\d]/g, '')
      if (k === '-1') {
        // 更新模型值
        this.$set(this.personInfo, fieldCode, value)
      } else {
        this.$set(this.model.temp[k], fieldCode, value)
      }
    },

    // 省市联动
    handleProvinceChange(e, ind) {
      console.log('=== FormmsgNew handleProvinceChange 被调用 ===')
      console.log('省份选择事件 e:', e, 'ind:', ind)
      const that = this
      const params = 'pid=' + e.key + '&language=' + this.globalLanguage
      console.log('FormmsgNew省市联动API请求参数:', params)

      getCityList(params).then(res => {
        console.log('FormmsgNew省市联动API返回:', res)
        if (res.success) {
          const cityList = res.result.map(ca => {
            return {
              ...ca,
              itemValue: ca.id,
              itemText: ca.title
            }
          })
          console.log('FormmsgNew省市联动处理后的城市列表:', cityList)

          if (ind === '-1') {
            console.log('FormmsgNew省市联动-个人信息数据')
            this.teamMemberList.forEach(item => {
              if (item.fieldCode === 'cityCode') {
                console.log('FormmsgNew省市联动-为个人信息设置城市列表')
                this.$set(item, 'list', cityList)
              }
            })
            this.personInfo.cityCode = undefined
          }
        } else {
          console.log('FormmsgNew省市联动API调用失败:', res.message || '未知错误')
        }
      }).catch(error => {
        console.error('FormmsgNew省市联动请求失败:', error)
      })
    },

    onChangeCompany1(e, k) {
      const newValue = e.target.value !== '02' ? '1' : '0'
      this.model.temp[k].teamList.forEach(item => {
        if (item.fieldCode === 'company') {
          item.isShow = newValue
          item.isDoubleCheck = e.target.value === '02'
        }
      })
    },

    // 获取学院列表
    async getCollegeList() {
      const { success, result } = await getCollegeList()
      if (success) {
        this.collegeList = result
      }
    },

    // 编辑模式下检查省份并加载城市数据
    async loadCityDataIfProvinceExists() {
      console.log('=== FormmsgNew loadCityDataIfProvinceExists 开始执行 ===')
      console.log('personInfo:', this.personInfo)

      // 检查个人信息的省份
      if (this.personInfo && this.personInfo.countryCode) {
        console.log('个人信息的countryCode:', this.personInfo.countryCode)
        let provinceKey = null

        // 处理不同格式的countryCode
        if (typeof this.personInfo.countryCode === 'object' && this.personInfo.countryCode.key) {
          provinceKey = this.personInfo.countryCode.key
        } else if (typeof this.personInfo.countryCode === 'string' && this.personInfo.countryCode) {
          provinceKey = this.personInfo.countryCode
        }

        if (provinceKey) {
          console.log('个人信息省份key:', provinceKey)
          await this.loadCityData({ key: provinceKey }, '-1')
        }
      }
    },

    // 加载城市数据的通用方法
    async loadCityData(countryCodeObj, ind) {
      try {
        console.log(`=== FormmsgNew loadCityData 开始执行，ind: ${ind} ===`)
        console.log('countryCodeObj:', countryCodeObj)
        console.log('globalLanguage:', this.globalLanguage)

        const params = 'pid=' + countryCodeObj.key + '&language=' + this.globalLanguage
        console.log('请求参数:', params)

        const res = await getCityList(params)
        console.log('API返回结果:', res)

        if (res.success) {
          const cityList = res.result.map(ca => {
            return {
              ...ca,
              itemValue: ca.id,
              itemText: ca.title
            }
          })
          console.log('处理后的城市列表:', cityList)

          if (ind === '-1') {
            // 个人信息数据
            console.log('处理个人信息城市数据，teamMemberList:', this.teamMemberList)
            this.teamMemberList.forEach(item => {
              if (item.fieldCode === 'cityCode') {
                console.log('找到cityCode字段，设置城市列表')
                this.$set(item, 'list', cityList)
                console.log('设置后的item:', item)
              }
            })
          }
        } else {
          console.log('API调用失败:', res.message || '未知错误')
        }
      } catch (error) {
        console.error('FormmsgNew加载城市数据失败:', error)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.cont {
  height: 60vh;
}

.btn-disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
}
::v-deep .ant-input-disabled {
  background-color: #f7f7f7;
  color: rgba(0, 0, 0, 0.65) !important;
}
::v-deep .ant-select-disabled {
  background-color: #f7f7f7 !important;
  color: rgba(0, 0, 0, 0.65) !important;
}
</style>
